import React from "react";
import { afField } from "@autodromo/contextual-fields";
import { formatGtagLabel } from "../../../utils/formatGtagLabel";
import { sanitizeSvg } from "../../../utils/sanitize";
import type { SubmenuLink } from "../HeaderV2.styles";
import { getLinkUrl, linkKey, shouldOpenInNewTab } from "../logic";
import type { HeaderV2Link } from "../types";

type SubmenuItemsProps = {
  link: HeaderV2Link;
  htmlId?: string;
  LinkComponent: typeof SubmenuLink;
};

export const SubmenuItems = ({ link, htmlId, LinkComponent }: SubmenuItemsProps) => (
  <>
    {(link.children ?? [])
      .filter((child) => child.isActive)
      .map((child, childIndex) => (
        <li key={linkKey({ link: child, index: childIndex })}>
          <LinkComponent
            href={getLinkUrl({ item: child })}
            target={shouldOpenInNewTab({ item: child }) ? "_blank" : "_self"}
            $withDescription={!!child.description}
            data-af-field={afField("links", link.id, "children", child.id, "name")}
            data-gtag-action="Clique Menu"
            data-gtag-label={formatGtagLabel(htmlId, child.name)}
            data-gtag-category="Cabeçalho"
          >
            {child.icon && (
              <span className="hv2-submenu-icon" aria-hidden="true" dangerouslySetInnerHTML={{ __html: sanitizeSvg(child.icon) }} />
            )}
            <span className="hv2-submenu-body">
              <span>{child.name}</span>
              {child.description && <span className="hv2-submenu-desc">{child.description}</span>}
            </span>
          </LinkComponent>
        </li>
      ))}
  </>
);
